import { BuildingContent } from "../../components/app";

export default function Building() {
  return <BuildingContent />;
}
